/**
 * PUB-010: client-side validation for opaque tokens in public email links.
 * Does not prove validity — only rejects obviously malformed input before hitting the network.
 */
const MIN_LEN = 16;
const MAX_LEN = 512;

export function isPlausiblePublicToken(raw: string | undefined | null): boolean {
  if (!raw || typeof raw !== 'string') return false;
  const t = raw.trim();
  if (t.length < MIN_LEN || t.length > MAX_LEN) return false;
  return /^[A-Za-z0-9._-]+$/.test(t);
}

export async function fetchWithTimeout(
  input: RequestInfo | URL,
  init: RequestInit & { timeoutMs?: number } = {}
): Promise<Response> {
  const { timeoutMs = 25_000, ...rest } = init;
  const ctrl = new AbortController();
  const id = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    return await fetch(input, { ...rest, signal: ctrl.signal });
  } finally {
    clearTimeout(id);
  }
}
